var React = require('react');

function CircleHollow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M4.5 6.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4zm0 1.5a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7z","fill":"currentColor"}));
}

CircleHollow.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9"};

module.exports = CircleHollow;

CircleHollow.default = CircleHollow;
